module.exports = __webpack_public_path__ + "img/icon-similar.c186b775.svg";